<script lang="ts">
  import BaseScene from "@engine/BaseScene.svelte";

  export let onResume: () => void;
  export let onRestart: () => void;
  export let onSettings: () => void;
  export let onQuit: () => void;
</script>

<BaseScene sceneId="pause" ariaLabel="Paused" onEscape={onResume}>
  <div class="pause" role="dialog" aria-modal="true">
    <h1>Paused</h1>
    <button type="button" class="pause__btn pause__btn--primary" on:click={onResume}>Resume</button>
    <button type="button" class="pause__btn" on:click={onRestart}>Restart</button>
    <button type="button" class="pause__btn" on:click={onSettings}>Settings</button>
    <button type="button" class="pause__btn" on:click={onQuit}>Quit to Title</button>
  </div>
</BaseScene>

<style>
  .pause {
    max-width: 400px;
    margin: 4rem auto;
    padding: 2rem;
    background: var(--color-surface);
    border-radius: 1rem;
    text-align: center;
  }
  .pause h1 {
    color: var(--color-heading);
    margin-bottom: 1.5rem;
  }
  .pause__btn {
    display: block;
    width: 100%;
    min-height: 44px;
    margin-bottom: 0.75rem;
    padding: 0.75em;
    background: var(--color-surface);
    color: var(--color-accent);
    border: 2px solid var(--color-accent);
    border-radius: 0.5em;
    font-size: 1.1rem;
    font-weight: 600;
    cursor: pointer;
  }
  .pause__btn--primary {
    background: var(--color-accent);
    color: var(--color-on-accent);
  }
  .pause__btn:focus-visible {
    outline: 3px solid var(--focus-ring);
    outline-offset: 2px;
  }
</style>
